import uploadcare from 'uploadcare-widget';
import { takeEvery } from 'redux-saga/effects';

import { SET_LOCALE, INITIALIZE_LOCALE } from '../intl/intlModule';



const getLanguage = locale => locale.split('-')[0];


export function initUploadcareLocale({ locale }) {
    window.UPLOADCARE_LOCALE = getLanguage(locale);
}


export function updateUploadcareLocale({ locale }) {
    uploadcare.plugin((uploadcareWidget) => {
        uploadcareWidget.locale.rebuild({ locale: getLanguage(locale) });
    });
}


export function* updateUYOForLanguageWatcher() {
    yield takeEvery(INITIALIZE_LOCALE, initUploadcareLocale);
    yield takeEvery(SET_LOCALE, updateUploadcareLocale);
}
